// src/business-types/saloon/modules/orders/saloon-order-display/hooks/useCancelHandler.ts
import { useState } from "react";
import { notifySuccess } from "src/assets/toastService";

export const useCancelHandler = (updateOrderStatus: (status: string, data: string) => Promise<boolean>) => {
  const [openCancelDialog, setOpenCancelDialog] = useState(false);
  const [cancelData, setCancelData] = useState("refund");

  const handleCancelOrder = async () => {
    const success = await updateOrderStatus("Cancelled", cancelData);
    notifySuccess("Order Cancel Successfully");
    if (success) setOpenCancelDialog(false);
  };

  return { cancelData, setCancelData, openCancelDialog, setOpenCancelDialog, handleCancelOrder };
};
